/**
 * @param   {EditorState}    editorState
 * @param   {SelectionState} currentSelection
 * @returns {Boolean}
 */
export default function hasEntityAtSelection(editorState, currentSelection) {
  const contentState = editorState.getCurrentContent();
  const startKey = currentSelection.getStartKey();
  const blockAtStartKey = contentState.getBlockForKey(startKey);
  const startOffset = currentSelection.getStartOffset();

  return blockAtStartKey.getEntityAt(startOffset - 1) ? true : false;
}
